import { useEffect, useState } from 'react';
import SignupSingleButton from './signup-single-button';

const StickyMobileCta: React.FC<{
  observeTargetId: string;
  stateCode: string;
  formSubmitText?: string;
}> = ({ observeTargetId, stateCode, formSubmitText = 'Get your card' }) => {
  const [showSticky, setShowSticky] = useState(false);

  useEffect(() => {
    const target = document.getElementById(observeTargetId);
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowSticky(!entry.isIntersecting);
      },
      { threshold: 0 },
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, [observeTargetId]);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-white border-t border-gray-200 px-4 py-3 transition-transform duration-300 ${
        showSticky ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <SignupSingleButton
        stateCode={stateCode}
        formSubmitText={formSubmitText}
        className="w-full"
        ctaLocation="sticky-mobile-cta"
      />
    </div>
  );
};

export default StickyMobileCta;
